import { Controller } from "@hotwired/stimulus";

const ICONS = {
  attending: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-full h-full"><path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd"/></svg>`,
  absent: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-full h-full"><path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg>`,
};

const SELECTED_CLASSES = {
  attending: ["bg-theme-500", "ring-theme-200"],
  absent: ["bg-red-600", "ring-red-300"],
};

const SHARED_SELECTED_CLASSES = ["text-theme-100", "shadow-2xl", "scale-105", "ring-4", "ring-offset-2"];

// Connects to data-controller="rsvp"
export default class extends Controller {
  static targets = [
    "status",
    "remarksContainer",
    "submit",
    "guestContainer",
    "guestCheckbox",
    "guestField",
    "rsvpButton",
  ];

  setResponse(event) {
    const button = event.currentTarget;
    const type = button.dataset.rsvpType;
    if (!type) return;

    this.rsvpButtonTargets.forEach((btn) => this.deselect(btn));
    this.select(button, type);

    this.statusTarget.value = type;
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;

    this.toggleRemarks(type === "absent");
    this.toggleGuestSection(type === "attending");
  }

  toggleGuestFields(event) {
    this.setGuestFieldsVisible(event.currentTarget.checked);
  }

  select(button, type) {
    button.classList.add(...SHARED_SELECTED_CLASSES, ...SELECTED_CLASSES[type]);
    const icon = button.querySelector(".rsvp-icon");
    if (icon) {
      icon.innerHTML = ICONS[type];
      icon.classList.remove("hidden");
    }
  }

  deselect(button) {
    button.classList.remove(
      ...SHARED_SELECTED_CLASSES,
      ...SELECTED_CLASSES.attending,
      ...SELECTED_CLASSES.absent
    );
    const icon = button.querySelector(".rsvp-icon");
    if (icon) {
      icon.innerHTML = "";
      icon.classList.add("hidden");
    }
  }

  toggleRemarks(show) {
    if (!this.hasRemarksContainerTarget) return;
    this.remarksContainerTarget.classList.toggle("hidden", !show);
    const textarea = this.remarksContainerTarget.querySelector("textarea");
    if (textarea) textarea.toggleAttribute("required", show);
  }

  toggleGuestSection(show) {
    if (!this.hasGuestContainerTarget) return;
    this.guestContainerTarget.style.display = show ? "flex" : "none";

    if (this.hasGuestCheckboxTarget) this.guestCheckboxTarget.checked = false;
    this.setGuestFieldsVisible(false);
  }

  setGuestFieldsVisible(show) {
    this.guestFieldTargets.forEach((field) => {
      field.style.display = show ? "block" : "none";
    });
  }
}
